import { inject, computed, useSlots, openBlock, createElementBlock, createVNode, withCtx, createElementVNode, normalizeClass, renderSlot, createCommentVNode, createBlock } from "vue";
import ErrorIcon from "../../uikit.icons/ErrorIcon.vue.es.js";
import SuccessIcon from "../../uikit.icons/TickIcon.vue.es.js";
import WarningIcon from "../../uikit.icons/WarningIcon.vue.es.js";
import UikitSkeleton from "../Skeleton.vue.es.js";
import Loader from "../Loader.vue.es.js";
/* empty css                     */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = { class: "uikit-input" };
const _hoisted_2 = {
  key: 0,
  class: "prefix"
};
const _hoisted_3 = {
  key: 1,
  class: "suffix"
};
const _hoisted_4 = {
  key: 2,
  class: "status-icon"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 1,
  class: "uikit-input-warning"
};
const _sfc_main = {
  __name: "InputWrapper",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    skeleton: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: void 0
    }
  },
  setup(__props) {
    const INPUT_STATUS = {
      NONE: "none",
      ERROR: "error",
      WARNING: "warning",
      SUCCESS: "success",
      LOADING: "loading"
    };
    const props = __props;
    const isFormDisabled = inject("isFormDisabled", false);
    const isFormSkeleton = inject("isFormSkeleton", false);
    const displaySkeleton = computed(() => isFormSkeleton.value || props.skeleton);
    const slots = useSlots();
    const hasPrefix = computed(() => !!slots.prefix);
    const hasSuffix = computed(() => !!slots.suffix);
    const status = computed(() => {
      if (props.errorMessage) {
        return INPUT_STATUS.ERROR;
      } else if (slots.warning) {
        return INPUT_STATUS.WARNING;
      } else {
        return INPUT_STATUS.NONE;
      }
    });
    const isError = computed(() => status.value === INPUT_STATUS.ERROR);
    const isWarning = computed(() => status.value === INPUT_STATUS.WARNING);
    const isSuccess = computed(() => status.value === INPUT_STATUS.SUCCESS);
    const isDisabled = computed(() => isFormDisabled.value || props.disabled);
    const isLoading = computed(() => props.loading);
    const hasStatusIcon = computed(() => isError.value || isSuccess.value || isLoading.value);
    const inputWrapperClasses = computed(() => ({
      "uikit-input-wrapper-error": isError.value,
      "uikit-input-wrapper-success": isSuccess.value,
      "uikit-input-wrapper-warning": isWarning.value,
      "uikit-input-wrapper-disabled": isDisabled.value
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(UikitSkeleton, {
          type: "input",
          loading: displaySkeleton.value
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(["uikit-input-wrapper", inputWrapperClasses.value])
            }, [
              hasPrefix.value ? (openBlock(), createElementBlock("span", _hoisted_2, [
                renderSlot(_ctx.$slots, "prefix", {}, void 0, true)
              ])) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "input", {}, void 0, true),
              hasSuffix.value ? (openBlock(), createElementBlock("span", _hoisted_3, [
                renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
              ])) : createCommentVNode("", true),
              hasStatusIcon.value ? (openBlock(), createElementBlock("span", _hoisted_4, [
                isError.value ? (openBlock(), createBlock(ErrorIcon, {
                  key: 0,
                  class: "error-icon",
                  full: true
                })) : isSuccess.value ? (openBlock(), createBlock(SuccessIcon, {
                  key: 1,
                  class: "success-icon"
                })) : isLoading.value ? (openBlock(), createBlock(Loader, {
                  key: 2,
                  show: true,
                  transparent: true,
                  width: "20px",
                  height: "20px",
                  class: "loading-icon"
                })) : createCommentVNode("", true)
              ])) : createCommentVNode("", true)
            ], 2)
          ]),
          _: 3
        }, 8, ["loading"]),
        __props.errorMessage ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "uikit-input-error",
          innerHTML: __props.errorMessage
        }, null, 8, _hoisted_5)) : isWarning.value ? (openBlock(), createElementBlock("div", _hoisted_6, [
          createVNode(WarningIcon, { class: "warning-icon" }),
          renderSlot(_ctx.$slots, "warning", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
};
const UikitInputWrapper = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-595a18dc"]]);
export {
  UikitInputWrapper as default
};
//# sourceMappingURL=InputWrapper.vue.es.js.map
